var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeaderBackgroundHd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "xMidYMid slice",
    width: 3862,
    height: 503,
    viewBox: "0 0 3862 503",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2107_57818)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3862,
    height: 503,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3862,
    height: 503,
    fill: "url(#paint0_linear_2107_57818)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M581.679 648.235C626.708 342.899 1208.27 123.838 1651.95 107.478C2163.25 88.664 2367.9 343.625 2753.19 245.669C3104.79 156.366 3113.97 -101.752 3373.06 -154.178C3611.17 -202.351 3997.72 -64.1762 4658.17 676.92",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4629.91 712.383C3977.57 -17.935 3590.53 -162.106 3348.7 -120.672C3169.48 -89.7863 3105.71 38.2555 2969.13 142.298C2901.03 195.755 2816.13 236.546 2722.06 261.009C2413.92 341.317 2221.78 203.435 1886.42 155.821C1800.93 143.499 1713.42 138.531 1625.71 141.018C1180 152.603 603.855 345.773 549.206 640.505",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4601.58 747.746C3957.35 28.2577 3570.03 -121.867 3325 -87.1431C3144.88 -61.6068 3076.71 60.6693 2939.62 159.764C2869.75 211.49 2784.94 251.354 2691.65 276.318C2388.04 357.518 2196.64 234.151 1860.25 189.515C1774.76 178.042 1687.59 173.037 1600.12 174.581C1152.35 182.387 581.651 348.617 517.382 632.745",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4573.31 783.001C3937.34 74.4924 3549.54 -81.5245 3301 -53.6533C3119.85 -33.3556 3047.57 83.037 2909.74 177.245C2838.26 227.205 2753.6 266.161 2661.17 291.629C2361.81 373.734 2171.79 264.802 1834.02 223.211C1748.48 212.452 1661.53 207.36 1574.24 208C1124.46 211.449 559.225 351.315 485.336 624.839",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4545.05 818.516C3917.18 120.681 3529.19 -41.1363 3276.93 -20.1084C3094.96 -5.00694 3018.21 105.519 2879.72 194.681C2806.57 242.901 2721.91 280.994 2630.17 306.963C2335.07 389.973 2146.22 295.537 1806.91 256.947C1721.5 247.037 1634.97 241.92 1548.07 241.64C1096.21 240.736 536.443 354.289 452.861 617.213",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4517.08 853.915C3897.1 166.868 3508.39 -5.8031 3252.86 13.3854C3070.46 26.9365 2988.84 127.636 2849.84 212.163C2775.06 258.563 2690.4 295.788 2599.4 322.288C2308.54 406.204 2121 326.256 1780.68 290.696C1695.33 281.501 1609.09 276.309 1522.48 275.151C1068.52 269.684 514.237 357.082 421.038 609.453",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4488.45 889.342C3876.94 213.108 3488.5 40.0069 3228.85 46.6137C3045.49 51.9394 2959.33 150.072 2819.89 229.7C2743.56 274.259 2658.9 310.638 2568.63 337.664C2282.01 422.485 2095.57 356.985 1754.15 324.458C1668.86 316.041 1582.9 310.808 1496.6 308.779C1040.56 298.958 491.734 359.834 388.922 601.759",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4460.2 924.753C3857.01 259.288 3468.23 80.2876 3204.8 80.4201C3020.76 80.334 2929.66 172.045 2789.95 247.132C2712.13 289.809 2627.42 325.327 2537.86 352.831C2255.56 438.607 2070.22 387.658 1727.63 358.011C1647.91 351.179 1562.87 345.009 1470.72 342.145C1012.51 327.818 469.25 362.744 356.813 593.96",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4431.94 960.165C3836.71 305.535 3447.98 121.143 3180.8 113.805C2996.03 108.781 2899.92 194.074 2759.85 264.519C2680.54 305.293 2595.74 340.017 2506.87 368.113C2228.82 454.794 2044.71 418.234 1700.88 391.73C1620.84 385.541 1536.01 379.466 1444.55 375.682C984.832 356.87 446.755 365.601 324.695 586.161",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4403.61 995.527C3816.56 351.725 3427.72 161.894 3156.74 147.456C2971.31 137.542 2869.83 216.224 2730.12 282.047C2649.43 320.891 2564.55 354.839 2476.39 383.529C2202.52 471.119 2019.58 449.055 1674.57 425.326C1594.55 419.764 1509.66 413.692 1418.88 409.039C956.555 385.531 424.249 368.146 292.572 578.153",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4375.34 1030.94C3796.47 397.91 3407.46 202.749 3132.88 180.938C2946.79 166.187 2840.22 238.141 2700.32 299.577C2618.25 336.414 2533.23 369.568 2445.76 398.847C2176.2 487.339 1994.43 479.718 1648.2 459.29C1567.85 454.476 1483.17 448.341 1393.15 442.869C928.727 414.642 401.979 371.254 260.537 570.664",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4347.08 1066.35C3776.32 444.151 3387.07 243.611 3108.67 214.438C2921.86 194.905 2810.11 260.029 2670.3 317.065C2589.93 349.829 2507.61 382.942 2414.85 414.178C2149.54 503.523 1968.94 510.45 1621.53 493.006C1541 488.881 1456.46 482.687 1366.98 476.405C900.461 443.459 379.198 374.072 228.21 562.927",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4318.82 1101.76C3756.18 490.55 3367.18 284.555 3084.68 247.98C2897.14 223.613 2780 281.814 2640.35 334.551C2557.95 365.68 2475.38 397.968 2384.07 429.502C2123.02 519.91 1943.65 541.12 1595.01 526.717C1514.29 523.332 1429.82 517.083 1341.25 509.922C872.692 472.15 356.848 376.872 196.243 555.175",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4290.71 1137.17C3736.09 536.58 3346.5 325.587 3060.68 281.523C2872.42 252.479 2749.88 303.546 2610.41 352.088C2525.89 381.482 2443.14 412.993 2353.59 444.866C2096.71 536.026 1918.66 571.882 1568.49 560.531C1487.51 557.787 1403.25 551.476 1315.37 543.551C844.705 500.85 334.351 379.677 164.128 547.428",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4262.23 1172.54C3715.93 582.769 3326.33 366.7 3036.61 315.016C2847.55 281.246 2719.69 325.124 2580.53 369.518C2493.9 397.123 2410.83 427.969 2322.53 460.152C2070.04 552.21 1893.01 602.517 1541.96 594.189C1457.29 591.544 1373 585.763 1289.41 576.868C816.79 529.495 311.643 382.597 132.013 539.63",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4233.97 1207.95C3695.78 629.009 3305.58 407.683 3012.83 348.495C2822.98 310.051 2689.7 346.64 2550.51 387.005C2461.77 412.771 2378.52 442.944 2291.76 475.475C2043.44 568.442 1867.65 633.242 1515.58 627.891C1431.02 626.034 1346.88 620.239 1263.68 610.541C788.856 557.825 289.361 385.392 99.8141 531.677",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4205.71 1243.36C3675.69 675.195 3284.84 449.031 2988.54 381.998C2798.05 338.978 2659.28 368.071 2520.63 404.435C2429.77 428.308 2346.36 457.965 2261.06 490.797C2017.06 584.665 1842.36 663.912 1488.91 661.608C1404.46 660.47 1320.46 654.607 1237.65 644.071C761.016 586.518 266.869 388.249 67.7115 524.139",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4177.37 1278.77C3655.55 721.645 3264.67 490.197 2964.54 415.54C2773.04 367.856 2629.07 389.389 2490.75 421.916C2397.48 443.806 2314.12 472.938 2230.28 506.121C1990.53 600.79 1817.08 694.634 1462.38 695.37C1378.05 694.918 1294.18 688.986 1211.77 677.647C733.161 615.002 244.369 391.054 35.5939 516.392",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4149.11 1314.18C3635.75 767.609 3244.08 531.487 2940.49 449.243C2748.12 396.992 2598.95 410.86 2460.82 439.715C2365.66 459.755 2281.76 488.283 2199.53 521.759C1964.02 617.439 1791.74 725.674 1435.87 729.289C1351.66 729.524 1267.9 723.523 1185.9 711.38C705.32 643.592 221.533 394.242 3.49485 508.855",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4120.85 1349.59C3615.31 813.864 3223.41 572.78 2916.48 482.576C2723.11 425.713 2568.79 431.808 2430.86 456.886C2333.56 474.616 2249.58 502.991 2168.75 536.874C1937.56 633.456 1766.45 756.135 1409.34 762.894C1325.26 763.842 1241.59 757.77 1160.02 744.798C677.525 671.707 199.385 396.717 -28.628 500.899",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4092.52 1384.96C3595.16 860.053 3202.75 614.334 2892.71 516.056C2698.4 454.682 2539.01 452.896 2401.28 474.354C2301.84 489.827 2217.63 517.95 2138.34 552.025C1911.33 649.568 1741.38 786.743 1383.1 796.486C1299.13 798.094 1215.53 791.951 1134.35 778.207C650.291 699.378 177.183 399.561 -60.5977 493.094",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4064.33 1420.36C3270.41 585.97 2729.72 445.142 2371.03 491.853C1979.47 542.836 1841.47 812.951 1356.29 830.261C787.12 850.511 196.316 388.326 -92.8605 485.354",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2107_57818",
    x1: 2213.76,
    y1: 0.000116461,
    x2: 2213.76,
    y2: 588.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C83A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C83A4",
    stopOpacity: 0.22
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2107_57818"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3862,
    height: 503,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderBackgroundHd);
export default __webpack_public_path__ + "static/media/Header_background_HD.e2adfd1d2937977180b0aae5391e5cca.svg";
export { ForwardRef as ReactComponent };